<template>
    <DefaultLayout>
        <h1 class="h5 mt-2">
            <div>
                <span class="small text-muted">{{ i18n('Audit') }}</span>
            </div>
        </h1>

        <AuditLoginFilter :filters="filters">
            <h1 class="h5 mt-2">
                {{ i18n('Login') }}
                <span class="small text-muted" v-if="!pagination?.total">({{ loginLogs.length }})</span>
                <span class="small text-muted" v-else>({{ pagination?.total }})</span>
            </h1>
            <template #buttons>
                <ExportToExcelAction cssClass="btn btn-sm btn-outline-dark ms-1" />
            </template>
        </AuditLoginFilter>

        <AuditLoginList :pagination="pagination" :loginLogs="loginLogs" :loading="loading"
            :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
            @next="nextPage" @goToPage="goToPage" />
    </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import api from "@/api.js"
import AuditLoginFilter from "@/components/auditLogin/AuditLoginFilter.vue";
import AuditLoginList from "@/components/auditLogin/AuditLoginList.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";

export default {
    mixins: [paginatedViewMixin,],
    components: {
        DefaultLayout,
        ExportToExcelAction,
        AuditLoginFilter,
        AuditLoginList,
    },
    data() {
        return {
            listPropertyName: 'loginLogs',
            apiResource: `loginLogs`,
            loginLogs: [],
        }
    },
    created() {
        this.filters.created_at_from = new Date().toISOString().split('T')[0];
    },
    mounted() {
        this.$root.setPageTitle(this.i18n('Changes audit'));
        api.auth().then((user) => {
            this.$root.loggedUser = user;

            if (!user.loggedIn) {
                return; // Layout non-anonymous will handler redirect
            }

            if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
                this.$router.push({ name: 'Index', });
                return;
            }

            this.load();
        });
    },
    watch: {
        params: {
            handler() {
                this.pagination.loadPages = 1;
                this.reload();
            },
            deep: true,
        },
    },
    methods: {
        extendApiParams(params) {
            params.acl = 'loginLog';
        },
    },
};

</script>